/*
  getDefaultScenario.js
*/

/**
 * Returns a default scenario as botech data.
 */
export default function getDefaultScenario() {

  // TODO: Adjust once API done.

  return {
    "metadata": {
      "author": "rory watts",
      "timestamp": "2022-11-11T08:57:00",
      "title": "Default scenario"
    },
    "nodes": [
      {
        "id": "lmko6ql9",
        "label": "population",
        "color": "#E5EF73",
        "x": 37.73,
        "y": 4.92
      },
      {
        "id": "lmko72v2",
        "label": "stage I",
        "color": "#AAAAAA",
        "x": 4.41,
        "y": 14.03
      },
      {
        "id": "lmko7f76",
        "label": "stage II",
        "color": "#AAAAAA",
        "x": 7.89,
        "y": -13.11
      },
      {
        "id": "lmko7p3c",
        "label": "mortality",
        "color": "#FB6375",
        "x": -26.43,
        "y": 12.87
      },
      {
        "id": "lmko7zx2",
        "label": "recovery",
        "color": "#3CD009",
        "x": -23.6,
        "y": -18.71
      }
    ],
    "links": [
      {
        "source": "lmko72v2",
        "target": "lmko7p3c"
      },
      {
        "source": "lmko7f76",
        "target": "lmko7p3c"
      },
      {
        "source": "lmko72v2",
        "target": "lmko7zx2"
      },
      {
        "source": "lmko7f76",
        "target": "lmko7zx2"
      },
      {
        "source": "lmko7zx2",
        "target": "lmko7p3c"
      },
      {
        "source": "lmko6ql9",
        "target": "lmko72v2"
      },
      {
        "source": "lmko6ql9",
        "target": "lmko7f76"
      }
    ]
  };
}
